"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Emoji = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Emoji = function Emoji() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.992 3.667c-4.6 0-8.325 3.733-8.325 8.333s3.725 8.334 8.325 8.334c4.608 0 8.341-3.734 8.341-8.334S16.6 3.667 11.992 3.667zm-2.909 5c.692 0 1.25.558 1.25 1.25s-.558 1.25-1.25 1.25c-.691 0-1.25-.558-1.25-1.25s.559-1.25 1.25-1.25zm6.842 5.6C15.167 15.892 13.7 17 12 17c-1.7 0-3.167-1.108-3.925-2.733a.418.418 0 01.375-.6h7.1c.308 0 .508.325.375.6zm-1.008-3.1c-.692 0-1.25-.558-1.25-1.25s.558-1.25 1.25-1.25c.691 0 1.25.558 1.25 1.25s-.559 1.25-1.25 1.25z",
    clipRule: "evenodd"
  });
};

exports.Emoji = Emoji;